import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    heading: '1. Introduction',
    body: [
      `Welcome to O!ng Lab.`,
      `These Terms of Use (“Terms”) are the rules for using our website and services at www.oinglab-korean.com.`,
      `When you create an account or use our services, you agree to these Terms. Please read them carefully. If you do not agree, please do not use the service.`,
    ],
  },
  {
    heading: '2. Service provider and contact',
    body: [
      `This service is operated by O!ng Lab.`,
      `· Website: www.oinglab-korean.com`,
      `· Email: contact@oinglab-korean.com`,
      `· Business name: 오잉랩 (O!ng Lab)`,
      `· Business registration number: 179-45-01005`,
      `· Business address: 경기도 수원시 광교호수공원로277번길`,
    ],
  },
  {
    heading: '3. Eligibility and account registration',
    body: [
      `You need an account to use most features.`,
      `When you sign up, we ask for your email address, name, country and city, and date of birth. Gender is optional.`,
      `Please give accurate information and keep it up to date.`,
      `You must be 18 years or older to use the service. (See also Privacy Policy, Section 19.)`,
    ],
  },
  {
    heading: '4. Your account and security',
    body: [
      `You are responsible for your account.`,
      `· Keep your password private. Do not share your account.`,
      `· If you think someone else used your account, contact us at contact@oinglab-korean.com.`,
      `We may pause an account to protect you or other users.`,
    ],
  },
  {
    heading: '5. Services provided by O!ng',
    body: [
      `O!ng Lab helps global users learn Korean language and culture, build careers, and settle in Korea.`,
      `Our services include:`,
      `· Workshops and live sessions`,
      `· Video courses`,
      `· Digital learning materials`,
      `· Bundles (two or more products together)`,
      `· Career and settlement support tools`,
      `We may add, change, or improve services over time.`,
    ],
  },
  {
    heading: '6. Workshops, courses, digital materials, and bundles',
    body: [
      `We sell different product types. Each type has its own rules:`,
      `· Offline workshop — an in-person event in Korea, on a fixed date`,
      `· Online live session — a real-time online session, on a fixed date and time`,
      `· Video course — recorded lessons you watch on O!ng`,
      `· Downloadable material — files (like PDFs) you can save to your device`,
      `· View-only material — content you can read inside O!ng, but not download`,
      `· Bundle — two or more of the products above, sold together`,
      `The product page shows the details for each product: schedule, access period, price, and a refund summary. Please read the product page before you buy.`,
    ],
  },
  {
    heading: '7. Paid services, payment, currency, and refunds',
    body: [
      `Some products are paid.`,
      ``,
      `Prices and currency:`,
      `· Prices are shown in USD.`,
      `· If you choose a Korean card at checkout, the price switches to KRW automatically. You will see the exact KRW amount before you pay.`,
      `· Korean cards are charged in KRW. Overseas cards and PayPal are charged in USD.`,
      ``,
      `Payment:`,
      `· Before payment, you will confirm the refund policy for that product with a checkbox. You cannot pay without confirming.`,
      `· Payments are handled by Toss Payments, our payment provider. O!ng does not store your card number on our servers.`,
      ``,
      `Refund summary:`,
      `· Before you start using a product, a full refund may be available within the eligible period.`,
      `· After use begins (watching, downloading, viewing, or attending), refunds may be limited.`,
      `· We always review exceptions, such as duplicate payment, technical errors, O!ng’s fault, or cases required by law.`,
      `· Refunds are made in the currency you paid (KRW or USD).`,
      `The full rules are in our Refund Policy.`,
    ],
  },
  {
    heading: '8. PayPal, overseas cards, Korean cards, and payment processing',
    body: [
      `Payments are processed by Toss Payments. We support, or plan to support:`,
      `· Korean cards — charged in KRW`,
      `· Overseas cards — charged in USD`,
      `· PayPal — charged in USD`,
      ``,
      `Please note:`,
      `· Refunds go to your original payment method, in the currency you paid.`,
      `· For USD payments, exchange rate changes and payment provider fees may affect the final amount you receive.`,
      `· PayPal transaction fees may not be returned when a payment is cancelled.`,
      `These points are also explained before you pay.`,
    ],
  },
  {
    heading: '9. User responsibilities',
    body: [
      `When you use O!ng, please:`,
      `· Give true and accurate information`,
      `· Use the service only for personal, lawful purposes`,
      `· Respect other learners, creators, and staff`,
      `· Keep paid content for your own use only`,
    ],
  },
  {
    heading: '10. Prohibited activities',
    body: [
      `Please do not:`,
      `· Share your account so others can use paid content`,
      `· Copy, record, download (when not allowed), resell, or share paid content outside O!ng`,
      `· Record workshops or live sessions without permission`,
      `· Harass, threaten, or harm other users or staff`,
      `· Use the service for anything illegal`,
      `· Disturb or damage the service, or access it with automated tools without our permission`,
      `· Provide false information or pretend to be someone else`,
      `If this happens, we may limit or close the account. (See Section 16.)`,
    ],
  },
  {
    heading: '11. Content ownership and license',
    body: [
      `Course content, materials, and the O!ng platform belong to O!ng Lab or to the creators who made them.`,
      `When you buy a product, you get a personal, non-transferable license to use it for yourself. You do not own the content, and you may not reuse, resell, or redistribute it.`,
    ],
  },
  {
    heading: '12. User-generated content',
    body: [
      `If you post content on O!ng (such as questions or reviews):`,
      `· It stays yours.`,
      `· You allow O!ng to show it inside the service.`,
      `· We may remove content that breaks these Terms or harms others.`,
    ],
  },
  {
    heading: '13. Workshop participation rules',
    body: [
      `Booking and seats:`,
      `· When you start booking, a seat may be held for you for a short time while you complete payment.`,
      `· If payment is not completed within the payment window (15 minutes), the hold ends and the seat is released.`,
      `· If an event is sold out, you can join the waitlist.`,
      `· When a seat opens, we send you an offer by email. The offer is valid for a limited time (3 hours). If you do not complete payment in time, the seat goes to the next person.`,
      `· Waitlist offers are first come, first served.`,
      `· Your booking is confirmed when payment is complete.`,
      `· You can ask to move your booking to another date of the same workshop, up to 7 days before the event, if seats are available. Contact us at contact@oinglab-korean.com to request a move.`,
      `· After payment, cancellations are handled by our support team. Before payment, you can cancel directly in the service.`,
      ``,
      `Attending:`,
      `· Please arrive on time. Check the date, time, and place on the product page.`,
      `· Live session times are shown in KST (Korea Standard Time, UTC+9). Please check your local time.`,
      `· If you do not attend and did not cancel in advance, this is a no-show. Refunds may be limited.`,
      `· If O!ng cancels an event, all participants receive a full refund.`,
      `· If O!ng changes the date, you can accept the new date or receive a full refund.`,
    ],
  },
  {
    heading: '14. Digital content access rules',
    body: [
      `· Access starts after payment is complete, unless the product page says otherwise.`,
      `· The access or viewing period is shown on the product page.`,
      `· When the period ends, you can no longer open the content.`,
      `· View-only materials cannot be downloaded.`,
      `· Do not copy or share digital content outside O!ng.`,
    ],
  },
  {
    heading: '15. Cancellation and refunds',
    body: [
      `Cancellation and refund rules depend on the product type and on whether use has started.`,
      `The full rules are in our Refund Policy. The Refund Policy is part of these Terms.`,
      `For refund requests, contact contact@oinglab-korean.com.`,
    ],
  },
  {
    heading: '16. Service changes, suspension, or termination',
    body: [
      `· We may change, pause, or stop parts of the service. We will give notice of important changes.`,
      <>
        · If a paid product is affected, refunds follow the{' '}
        <Link to='/refund-policy' className='underline'>
          Refund Policy
        </Link>
        .
      </>,
      `· If an account seriously or repeatedly breaks these Terms, we may suspend or close it. We will explain why, and how to contact us about the decision.`,
      `· You can stop using the service and delete your account at any time. (See the Privacy Policy for what happens to your data.)`,
    ],
  },
  {
    heading: '17. Disclaimers',
    body: [
      `We work hard to provide a reliable service. However, to the extent allowed by law:`,
      `· The service is provided “as is.”`,
      `· We do not guarantee specific results, such as a job, a visa, or an exam score.`,
      `· We do not guarantee that the service will always be available without interruption.`,
    ],
  },
  {
    heading: '18. Limitation of liability',
    body: [
      `To the extent allowed by law, O!ng Lab’s liability for damages related to the service is limited.`,
      `This section does not limit any rights you have under consumer protection law that cannot be limited by agreement.`,
    ],
  },
  {
    heading: '19. Privacy',
    body: [
      `We care about your personal information.`,
      <>
        How we collect, use, and protect it is explained in our{' '}
        <Link to='/privacy' className='underline'>
          Privacy Policy
        </Link>
        .
      </>,
    ],
  },
  {
    heading: '20. Changes to these Terms',
    body: [
      `We may update these Terms from time to time.`,
      `· The “Last updated” date at the top shows the latest version.`,
      `· For important changes, we will notify you by email or with a notice on the site, before the change takes effect.`,
      `· If you keep using the service after a change takes effect, the new Terms apply.`,
    ],
  },
  {
    heading: '21. Governing law and dispute resolution',
    body: [
      `These Terms follow the laws of the Republic of Korea.`,
      `If you have a problem, please contact us first — most issues can be solved quickly by email.`,
      `If we cannot solve it together, disputes are handled under Korean law and jurisdiction.`,
    ],
  },
  {
    heading: '22. Contact',
    body: [
      `Questions about these Terms?`,
      `Email us: contact@oinglab-korean.com`,
      `We usually reply within 3 business days.`,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: 'Terms of Use',
  lastUpdated: 'June 11, 2026',
  effectiveDate: '2026-06-11',
  sections,
};
